import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, Button } from '../components/ui';
import { motion, useReducedMotion, type Variants } from 'motion/react';

export default function CheckoutCancelPage() {
    const { t } = useTranslation('billing');
    const navigate = useNavigate();
    const prefersReducedMotion = useReducedMotion();

    // Minimal entrance for short checkout result page.
    const panelVariants: Variants = {
        hidden: prefersReducedMotion ? { opacity: 1 } : { opacity: 0, y: 12 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] as const } },
    };

    const handleGoToProfile = () => {
        navigate('/profile');
    };

    const handleTryAgain = () => {
        navigate('/profile');
    };

    return (
        <div className="min-h-screen bg-snapfy-bg flex items-center justify-center p-4">
            <motion.div
                className="max-w-md w-full"
                variants={panelVariants}
                initial="hidden"
                animate="visible"
            >
                <Card className="p-8 text-center">
                    <div className="w-16 h-16 bg-snapfy-error/20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <XCircle className="w-10 h-10 text-snapfy-error" />
                    </div>
                    <h1 className="text-2xl font-bold text-snapfy-text-primary mb-2">
                        {t('checkout.cancel.title', 'Pagamento Cancelado')}
                    </h1>
                    <p className="text-snapfy-text-secondary mb-6">
                        {t('checkout.cancel.message', 'Seu pagamento foi cancelado. Nenhuma cobrança foi feita em sua conta.')}
                    </p>
                    <div className="flex flex-col gap-3">
                        <Button
                            variant="solid"
                            className="w-full"
                            onClick={handleTryAgain}
                        >
                            {t('checkout.cancel.try_again', 'Tentar novamente')}
                        </Button>
                        <Button
                            variant="ghost"
                            className="w-full"
                            onClick={handleGoToProfile}
                        >
                            {t('checkout.cancel.go_back', 'Voltar ao perfil')}
                        </Button>
                    </div>
                </Card>
            </motion.div>
        </div>
    );
}
